import axios from 'axios';

const sendDiningForm = async (fullname, email, phoneno, message, selectedOption, selectDate) => {
    return axios({
        method: 'post',
        url: '/api/send-dining-mail',
        data: {
            fullname: fullname,
            email: email,
            phoneno: phoneno,
            message: message,
            selectedOption: selectedOption,
            selectDate: selectDate
        },
    });
};

export default sendDiningForm;